import { Reducer } from 'react';
import { NotificationPreferencesModel } from '../../models/NotificationPreferencesModel';
import { NotificationActionTypes, ReducerAction } from './actions';

export const reducer: Reducer<NotificationPreferencesModel, ReducerAction> = (state, action) => {
    switch (action.type) {
        case NotificationActionTypes.UpdateData: {
            return {
                ...(action.payload as NotificationPreferencesModel)
            };
        }

        default:
            return state;
    }
};
